import * as React from 'react';

import * as style from './IconCoversation.css';

export const IconCoversation: React.FC = () => {
  return <div className={style['icon']}></div>;
};
